module.exports = __webpack_public_path__ + "img/logo-mini-color.f8192e5e.png";